export const SKIP_AUTH_REDIRECT = 'skipAuthRedirect'
export const SET_AUTH_REDIRECT = 'setAuthRedirect'
